import vuetify from './vuetify';
import router from '../router';
import i18n from './i18n';
import type { App } from 'vue';
import pinia from './pinia';
import gtag from './gtag';
import { registerWebSocket } from '@/plugins/websocket';

export function registerPlugins(app: App) {
    app.use(i18n).use(vuetify).use(router).use(pinia).use(gtag);

    registerWebSocket(app);
}
